module.exports = __webpack_public_path__ + "img/15.81cd5a3d.jpg";